import React, { useEffect, useRef, useState } from "react";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import {
  addStaffEducationalInfo,
  removeStaffEducationalInfo,
  resetStaffStatus,
} from "../../../redux/slice/staff/staffSlice";
import useFileSelected from "../../../utils/hooks/useFileSelected";
import useInputChange from "../../../utils/hooks/useInputChange";
import { isEmptyObject } from "../../../utils/validators/validators";
import Form from "../../form/Form";
import EducationInfo from "../../modals/form/staff/EducationInfo";
import Preview from "../../modals/preview/document";
import { updateStaffEducationalInfo } from "./../../../redux/slice/staff/staffSlice";
import AddNewEmployment from "./AddNewEmployment";

function EducationalInfo() {
  const [hasEditStaff, setHasEditStaff] = useState();
  const [error, setError] = useState({});
  const [creating, setCreating] = useState(false);
  const [educationalInfo, setEducationalInfo] = useState({});
  const [editing, setEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const { education_information } = useSelector(
    (state) => state?.staff.staff_information
  );
  // const [currentEducationalInfo, setCurrentEducationalInfo] = useState([])
  const { isSuccess, staff_records } = useSelector((state) => state.staff);
  const { user_permissions } = useSelector((state) => state.auth?.user);

  // initialize input fields
  let initialInputs = {
    institution_name: "",
    start_date: new Date().toISOString().slice(0, 10),
    end_date: new Date().toISOString().slice(0, 10),
    course_of_study: "",
    document: {},
  };
  const [staffInputData, setStaffInputData] = useState(initialInputs);

  // handle input change
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );
  const [fileInput, fileChangeHandler] = useFileSelected(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );

  const dispatch = useDispatch();
  const certicateRef = useRef();

  // Reset state
  const resetState = () => {
    setStaffInputData({
      ...staffInputData,
      institution_name: "",
      start_date: new Date().toISOString().slice(0, 10),
      end_date: new Date().toISOString().slice(0, 10),
      course_of_study: "",
      document: {},
      updating: "updating",
    });
    setError({ ...{} });
  };

  // fetch uploaded educational information
  // const edu_info = () => staff_records.find(f => f.educational_info)

  //  edit button handler
  const editHandler = (id) => {
    setSelectedId(id);
    setEditing(true);
  };

  // submit form
  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      editing
        ? dispatch(updateStaffEducationalInfo(staffInputData))
        : dispatch(addStaffEducationalInfo(staffInputData));
    }
  };

  // delete educational info
  const handleDelete = (recordID) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeStaffEducationalInfo(recordID));
      }
    });
  };

  useEffect(() => {
    // let education_info = edu_info()
    // if(education_info){
    //     setCurrentEducationalInfo(education_info)
    // }
    if (isSuccess) {
      resetState();
    }
    return () => {
      if (creating) {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
      dispatch(resetStaffStatus());
    };
  }, [staff_records, isSuccess]);

  // set current state on component mount
  useEffect(() => {
    setEducationalInfo(education_information);
    if (education_information && selectedId) {
      setStaffInputData({
        ...staffInputData,
        app_id: educationalInfo[0]?.app_id,
      });
    }
  }, [education_information]);

  // Update state on click of edit button
  useEffect(() => {
    if (editing) {
      const selected = educationalInfo.filter((f) => f.id === selectedId)[0];
      setStaffInputData({
        ...staffInputData,
        institution_name: selected?.institution_name,
        course_of_study: selected?.course_of_study,
        id: selected?.id,
        start_date: new Date(selected.start_date).toISOString().slice(0, 10),
        end_date: new Date(selected.end_date).toISOString().slice(0, 10),
      });
    }
  }, [editing]);

  useEffect(() => {
    setHasEditStaff(
      user_permissions?.some((permission) => permission.name === "edit staff")
    );
  }, [user_permissions]);

  return (
    <div className='border p-4 rounded-3 mt-4 px-3 position-relative'>
      <h4 className='fw-bold text-primary bg-white position-absolute profile-title'>
        Educational Information
      </h4>

      {education_information && education_information?.length > 0 ? (
        <div>
          <div className='col-sm-12 table-responsive mb-4'>
            <AddNewEmployment
              creating={creating}
              setCreating={setCreating}
              education_information={education_information}
            />
            <table
              className='table table-centered table-striped dt-responsive nowrap w-100 dataTable no-footer dtr-inline collapsed'
              id='products-datatable'
              aria-describedby='products-datatable_info'
            >
              <thead>
                <tr>
                  <th style={{ width: "27.6px" }}>#</th>
                  <th style={{ width: "117.8px" }}>Institution Name</th>
                  <th style={{ width: "106.8px" }}>Start Date</th>
                  <th style={{ width: "106.8px" }}>End Date</th>
                  <th style={{ width: "96.8px" }}>Course of Study</th>
                  <th style={{ width: "75.6px" }}>Document</th>
                  {hasEditStaff && <th style={{ width: "55.8px" }}>Action</th>}
                </tr>
              </thead>
              <tbody>
                {education_information &&
                  education_information.map(
                    (
                      {
                        id,
                        course_of_study,
                        document,
                        institution_name,
                        start_date,
                        end_date,
                      },
                      index,
                      counter
                    ) => (
                      <tr key={id}>
                        <td>{index + 1}</td>
                        <td>{institution_name}</td>
                        <td>
                          <Moment date={start_date} format='DD-MM-YYYY' />
                        </td>
                        <td>
                          <Moment date={end_date} format='DD-MM-YYYY' />
                        </td>
                        <td>{course_of_study}</td>
                        <td className='link-primary'>
                          <a
                            href='/'
                            data-bs-toggle='modal'
                            data-bs-target={`#doc${id}`}
                          >
                            {document.split("/")[2]}
                          </a>
                        </td>
                        {hasEditStaff && (
                          <td className='text-danger'>
                            <a
                              href='/'
                              data-bs-toggle='modal'
                              data-bs-target={`#staticBackdrop_${id}`}
                              onClick={() => editHandler(id)}
                            >
                              <i className='mdi mdi-pencil text-success fs-4 me-2 '></i>
                            </a>
                            {counter.length > 1 && (
                              <span
                                className='pe-auto'
                                onClick={() => handleDelete(id)}
                                style={{ cursor: "pointer" }}
                              >
                                <i className='uil uil-times text-danger fs-4'></i>
                              </span>
                            )}
                          </td>
                        )}
                        <td>
                          <Preview document_url={document} id={`doc${id}`} />
                        </td>
                        <td>
                          <Form
                            setError={setError}
                            submitHandler={handleSubmit}
                            values={staffInputData}
                          >
                            <div
                              className='modal fade'
                              id={`staticBackdrop_${id}`}
                              data-bs-backdrop='static'
                              data-bs-keyboard='false'
                              tabIndex='-1'
                              aria-labelledby='staticBackdropLabel'
                              aria-hidden='true'
                            >
                              <div className='modal-dialog modal-lg'>
                                <div className='modal-content'>
                                  <div className='modal-header'>
                                    <h5
                                      className='modal-title'
                                      id='staticBackdropLabel'
                                    >
                                      {editing
                                        ? "Update Record"
                                        : "Add New Record"}
                                    </h5>
                                    <button
                                      type='button'
                                      className='btn-close'
                                      data-bs-dismiss='modal'
                                      aria-hidden='true'
                                      onClick={() => setEditing(false)}
                                    ></button>
                                  </div>
                                  <div className='modal-body'>
                                    <div className='row'>
                                      <div className='col-md-12'>
                                        {error.start_date && (
                                          <div className='alert alert-danger'>
                                            {error.start_date}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className='row g-'>
                                      <div className='mb-0 col-md-4'>
                                        <label
                                          htmlFor='email'
                                          className='form-label'
                                        >
                                          Institution Name
                                        </label>
                                        <input
                                          textname='Institution name'
                                          name='institution_name'
                                          onChange={handleChange}
                                          value={input.institution_name}
                                          type='text'
                                          className={`form-control ${
                                            error.institution_name &&
                                            "is-invalid"
                                          }`}
                                          id='email'
                                          placeholder='Institution Name'
                                        />
                                        {error.institution_name && (
                                          <span className='invalid-feedback'>
                                            {error.institution_name}
                                          </span>
                                        )}
                                      </div>
                                      <div className='col-md-4'>
                                        <div className='row'>
                                          <div className='mb-0 col-md-6'>
                                            <label
                                              htmlFor='inputEmail7'
                                              className='form-label'
                                            >
                                              Start Date
                                            </label>
                                            <input
                                              type='date'
                                              id='start_date'
                                              name='start_date'
                                              value={input.start_date}
                                              onChange={handleChange}
                                              className='form-control'
                                            />
                                          </div>

                                          <div className='mb-0 col-md-6'>
                                            <label
                                              htmlFor='inputEmail7'
                                              className='form-label'
                                            >
                                              End Date
                                            </label>
                                            <input
                                              name='end_date'
                                              value={input.end_date}
                                              onChange={handleChange}
                                              type='date'
                                              id='end_date'
                                              className='form-control'
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className='mb-0 col-md-4'>
                                        <label
                                          htmlFor='inputEmail8'
                                          className='form-label'
                                        >
                                          Course of Study
                                        </label>
                                        <input
                                          textname='Course name'
                                          name='course_of_study'
                                          onChange={handleChange}
                                          value={input.course_of_study}
                                          type='text'
                                          className={`form-control ${
                                            error.course_of_study &&
                                            "is-invalid"
                                          }`}
                                          id='inputEmail8'
                                          placeholder='Enter Course Name'
                                        />
                                        {error.course_of_study && (
                                          <span className='invalid-feedback'>
                                            {error.course_of_study}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className='my-3'>
                                      <label
                                        className='btn btn-primary'
                                        htmlFor='certificate'
                                        onClick={() => {
                                          certicateRef.current.click();
                                        }}
                                      >
                                        Browse Document
                                      </label>
                                      {fileInput.document && (
                                        <a href='#' className='ms-2 text-col'>
                                          {fileInput.document.name}
                                        </a>
                                      )}
                                      <input
                                        type='file'
                                        className='invisible'
                                        accept='image/*, application/pdf'
                                        name='document'
                                        onChange={fileChangeHandler}
                                        ref={certicateRef}
                                      />

                                      {/* <div className="float-end">
                                        <button disabled={isLoading && true} className="btn btn-success px-3" >Save </button>
                                    </div> */}
                                      <div className='clearfix'></div>
                                    </div>
                                  </div>
                                  <div className='modal-footer'>
                                    <a
                                      type='button'
                                      className='btn btn-secondary'
                                      data-bs-dismiss='modal'
                                      onClick={() => setEditing(false)}
                                    >
                                      Close
                                    </a>
                                    <button className='btn btn-primary'>
                                      {editing ? "Update Record" : "Add Record"}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Form>
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>
          </div>

          <div className='row'>
            <div className='d-flex justify-content-end'>
              <div>
                {/* data-bs-toggle="modal" data-bs-target="#staticModal" */}
                {hasEditStaff && (
                  <button
                    type='button'
                    className={`btn btn-primary btn-sm mt-3 px-3 text-white`}
                    onClick={() => {
                      setEditing(false);
                      setCreating(true);
                      setStaffInputData(initialInputs);
                    }}
                  >
                    <span>
                      <i className='mdi mdi-plus'></i>
                    </span>{" "}
                    Add New
                  </button>
                )}

                <EducationInfo />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className='alert alert-info'>No Record Found</div>
      )}
    </div>
  );
}

export default EducationalInfo;
